// 自定义页面头部配置 https://qm-base.qmniu.com/h5-ui/#/q-navigation#api
export const headerConfigBase = {
    title: '我的明细',
    fullScreen: true,
    menuConfig: {
        right: [
            {
                icon: '&#xe65f;',
                type: 'share',
            }
        ],
    },
    beginBufferNumber: 1,
    endBufferRatio: 1, // 两个都为1，表示不显示过渡效果（透明度）
    styleConfig: {
        default: {
            text: {
                color: '#fff',
                opacity: 1,
            },
            title: {
                color: '#fff',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'white',
        },
        fixed: {
            text: {
                color: '#111',
                opacity: 1,
            },
            title: {
                color: '#111',
                opacity: 1,
            },
            bg: {
                background: '#fff',
            },
            statusBar: 'black',
        },
    },
};

// 公证编号文案
export const notaryStr = ['【浦东公证处】(公证书编号:〔2026〕沪浦证经字第392号)', '【东方公证处】(公证书编号:〔2026〕沪东证经字第2421号)'];

// 支持优惠券的版本
export const supportCouponVersionMap = {
    android: 77580,
    ios: 7930010,
    harmonyos: 79300,
};

// 支持口令码的版本
export const supportPasswordVersionMap = {
    android: 75980,
    ios: 7600010,
    harmonyos: 79320,
};

// 支持金币的版本
export const supportCoinVersionMap = {
    android: 1,
    ios: 1,
    harmonyos: 76370,
};
